import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArchiveFileTitleRule } from '../models/archive/archive-file-title-rule.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ArchiveFileTitleRuleService extends RequestService<ArchiveFileTitleRule> {
  static PATH = '/archive/file/title/rule';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ArchiveFileTitleRuleService.PATH, globalService.debugUrl);
  }
}
